export function getChatMessageTimeoutInMs(index: number) {
  if (index === 0) return TIMEOUT_FOR_FIRST_MESSAGE_IN_MS;
  return (index + 1) * TIMEOUT_FOR_OTHER_MESSAGE_IN_MS;
}

const TIMEOUT_FOR_FIRST_MESSAGE_IN_MS = 2000;
const TIMEOUT_FOR_OTHER_MESSAGE_IN_MS = 3500;
